import type React from "react"
import { GripVertical, CreditCard, Grid3x3, Table, List } from "lucide-react"
import { ScrollArea } from "@/components/ui/scroll-area"

interface ComponentItem {
  id: string
  label: string
  icon: React.ReactNode
  type: string
  category: string
}

const components: ComponentItem[] = [
  {
    id: "card",
    label: "Card",
    icon: <CreditCard className="h-4 w-4" />,
    type: "card",
    category: "Components",
  },
  {
    id: "card_array",
    label: "Card Array",
    icon: <Grid3x3 className="h-4 w-4" />,
    type: "card_array",
    category: "Components",
  },
  {
    id: "table",
    label: "Table",
    icon: <Table className="h-4 w-4" />,
    type: "table",
    category: "Components",
  },
  {
    id: "list",
    label: "List",
    icon: <List className="h-4 w-4" />,
    type: "list",
    category: "Components",
  },
]

const categories = ["Components"]

export function ComponentPalette() {
  const handleDragStart = (e: React.DragEvent, component: ComponentItem) => {
    e.dataTransfer.setData("component", JSON.stringify({ ...component, icon: undefined }))
    e.dataTransfer.effectAllowed = "copy"
  }

  return (
    <div className="w-[200px] border-r border-border bg-background flex flex-col">
      <div className="border-b border-border px-4 py-3">
        <h3 className="font-semibold text-sm">Components</h3>
      </div>

      <ScrollArea className="flex-1">
        <div className="p-3">
          {categories.map((category) => (
            <div key={category} className="mb-6">
              <div className="px-2 py-1.5 text-xs font-semibold text-muted-foreground">{category}</div>
              <div className="space-y-0.5">
                {components
                  .filter((c) => c.category === category)
                  .map((component) => (
                    <div
                      key={component.id}
                      draggable
                      onDragStart={(e) => handleDragStart(e, component)}
                      className="px-3 py-2 text-sm rounded-md hover:bg-muted transition-colors cursor-move flex items-center gap-3 group"
                    >
                      <span className="text-muted-foreground">{component.icon}</span>
                      <span className="flex-1">{component.label}</span>
                      <GripVertical className="h-3 w-3 text-muted-foreground opacity-0 group-hover:opacity-100 transition-opacity" />
                    </div>
                  ))}
              </div>
            </div>
          ))}
        </div>
      </ScrollArea>
    </div>
  )
}
